export const CALENDAR_URL = 'https://calendly.com/klarops-sales/30min';
export const DISABLE_WORKSPACE_ACTIVATION_CHECK = true;
